<template>
  <div id="admin-menu">
    <div class="hover-leftline pt-4 px-3 sidebar">
      <img class="topbar-logo"
           src="@/assets/images/spade-logo.png"/>
      <br>
    </div>
    <sidebar-menu :menu="menu" theme="black-theme" width="20vw" :showOneChild="true" :hide-toggle="true">
    </sidebar-menu>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {

      menu: [
        {
          header: false,
          hiddenOnCollapse: true,
        },
        {
          title: "Survey list",
          href: "/survey",

        },
      ],
    }
  },
}
</script>
<style>
.v-sidebar-menu {
  position: relative;
  height: 100vh;
  background-color: #304156;
}

</style>